import { useQuery } from "@tanstack/react-query";

import { CheckoutSession } from "checkout-query-client/hooks/use-checkout-session";
import { MerchantSettings } from "checkout-query-client/hooks/use-merchant-settings";
import { PaymentType } from "checkout-query-client/types/form-types";
import { generatePaymentForm } from "checkout-query-client/utils/generate-payment-form";

interface Params {
  checkoutSession?: CheckoutSession;
  merchantSettings?: MerchantSettings;
  paymentType?: PaymentType;
  formId?: string;
  checkoutSessionToken?: string;
}

export const usePaymentForm = ({
  checkoutSessionToken,
  checkoutSession,
  formId,
  paymentType,
  merchantSettings,
}: Params) => {
  return useQuery({
    queryKey: [
      {
        scope: "form",
        formId,
        paymentType,
        checkoutSessionToken,
        merchantSettings,
        country: merchantSettings?.country,
        paymentMethods: checkoutSession?.paymentMethods,
      },
    ],
    queryFn: () =>
      generatePaymentForm(
        checkoutSession,
        merchantSettings,
        paymentType,
        formId
      ),
    enabled:
      !!paymentType && !!formId && !!checkoutSessionToken && !!checkoutSession,
  });
};
